(() => {
  const article = document.querySelector('[data-tpp-article]');
  if (!article) return;

  const body = article.querySelector('[data-tpp-article-body]');
  const toc = article.querySelector('[data-tpp-article-toc]');
  const list = article.querySelector('[data-tpp-toc-list]');

  if (!body || !toc || !list) return;

  const headings = Array.from(body.querySelectorAll('h2, h3'));
  if (headings.length < 2) {
    toc.remove();
    return;
  }

  const usedIds = new Set();

  const slugify = (value) => {
    const base = value
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');

    return base || 'section';
  };

  headings.forEach((heading) => {
    const baseId = heading.id || slugify(heading.textContent || '');
    let candidate = baseId;
    let suffix = 2;

    const idIsTaken = (value) => {
      const existing = document.getElementById(value);
      return usedIds.has(value) || (existing && existing !== heading);
    };

    while (idIsTaken(candidate)) {
      candidate = baseId + '-' + suffix;
      suffix += 1;
    }

    heading.id = candidate;
    usedIds.add(candidate);

    const item = document.createElement('li');
    item.dataset.level = heading.tagName === 'H3' ? '3' : '2';

    const link = document.createElement('a');
    link.href = '#' + candidate;
    link.textContent = heading.textContent.trim();
    link.addEventListener('click', () => {
      const details = toc.querySelector('details');
      if (window.matchMedia('(max-width: 989px)').matches && details) {
        details.removeAttribute('open');
      }
    });

    item.appendChild(link);
    list.appendChild(item);
  });

  toc.hidden = false;

  if ('IntersectionObserver' in window) {
    const linksById = new Map();
    list.querySelectorAll('a').forEach((link) => {
      linksById.set(link.getAttribute('href').slice(1), link);
    });

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        list.querySelectorAll('a[aria-current="true"]').forEach((link) => {
          link.removeAttribute('aria-current');
        });
        linksById.get(entry.target.id)?.setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-18% 0px -70% 0px', threshold: 0 });

    headings.forEach((heading) => observer.observe(heading));
  }
})();